import { BigNumber, ethers, providers } from 'ethers'
import abi from '../nftContractAbi.json'

export type ERC721 = {
  image: string
  description: string
}

export const mainnetProvider = new providers.AlchemyProvider(
  'mainnet',
  process.env.NEXT_PUBLIC_ALCHEMY_API_KEY
)

export const knxtProvider = new providers.AlchemyProvider()
// process.env.NEXT_PUBLIC_NFT_CONTRACT_NETWORK,
// process.env.NEXT_PUBLIC_ALCHEMY_API_KEY

const contract = new ethers.Contract(
  process.env.NEXT_PUBLIC_NFT_CONTRACT_ADDRESS ?? '',
  abi,
  knxtProvider
)

export const getNftTokenIdsForWallet = (
  walletId: string
): Promise<BigNumber[]> => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
  return contract.tokensOfOwner(walletId)
}

export const getNftTokenMetadataURI = (nftTokenId: string): Promise<string> => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
  return contract.tokenURI(nftTokenId)
}

export const getWalletENSName = async (
  walletAddress: string
): Promise<string | null> => {
  const ensName = await knxtProvider.lookupAddress(walletAddress)

  return ensName ?? null
}
